import { IRootState } from '../../../store'

export const getServiceIdSelector = (state: IRootState): string => state.user.serviceId
